import { useEffect } from 'react'
import { useMe } from '../users'
import { useGetAccountSubscriptionPlan } from '../accounts/use-get-account-subscription-plan.hook'
import { EAccountSubscriptionPlans } from 'src/types'

const useIntercom = () => {
  const { data: me, isLoading, isSuccess } = useMe()
  const { data: account, isLoading: isAccountLoading } = useGetAccountSubscriptionPlan()

  useEffect(() => {
    if (
      isSuccess &&
      me &&
      account &&
      account.subscription_plan !== EAccountSubscriptionPlans.free
    ) {
      const d = new Date(me.created_at as string)
      window.Intercom('boot', {
        api_base: 'https://api-iam.intercom.io',
        app_id: 'pcg5gtxa',
        name: me?.name || me.email,
        email: me?.email,
        created_at: d.getTime() / 1000,
      })
    } else {
      if (!isAccountLoading && !isLoading && !!window.Intercom) {
        window.Intercom('shutdown')
      }
    }
  }, [isSuccess, me, isLoading, isAccountLoading, account])
}

export default useIntercom
